import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { QaService } from '../../../services/qa.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit,OnDestroy {
  private subscription:Subscription;
  public progress:string;
  constructor(private qaService : QaService) { }

  ngOnInit() {
    this.subscription = this.qaService.progress.subscribe(x=>this.progress = x);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/shared/progress-bar/progress-bar.component.ts